/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  MintGatewayLogicV2,
  MintGatewayLogicV2Interface,
} from "../MintGatewayLogicV2";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes",
        name: "_to",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "_n",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "bytes",
        name: "_indexedTo",
        type: "bytes",
      },
    ],
    name: "LogBurn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "_n",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "_nHash",
        type: "bytes32",
      },
    ],
    name: "LogMint",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_newMintAuthority",
        type: "address",
      },
    ],
    name: "LogMintAuthorityUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "_directTransferOwnership",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "bytes32",
        name: "_pHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "_nHash",
        type: "bytes32",
      },
    ],
    name: "_legacy_hashForSignature",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "blacklistRecoverableToken",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "bytes",
        name: "_to",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "burnFee",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [],
    name: "claimOwnership",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [],
    name: "claimTokenOwnership",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "feeRecipient",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "uint256",
        name: "_n",
        type: "uint256",
      },
    ],
    name: "getBurn",
    outputs: [
      {
        internalType: "uint256",
        name: "_blocknumber",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_to",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "_chain",
        type: "string",
      },
      {
        internalType: "bytes",
        name: "_payload",
        type: "bytes",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "bytes32",
        name: "_pHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "_nHash",
        type: "bytes32",
      },
    ],
    name: "hashForSignature",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract RenERC20LogicV1",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_feeRecipient",
        type: "address",
      },
      {
        internalType: "address",
        name: "_mintAuthority",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "_mintFee",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "_burnFee",
        type: "uint16",
      },
      {
        internalType: "uint256",
        name: "_minimumBurnAmount",
        type: "uint256",
      },
    ],
    name: "initialize",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "_nextOwner",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "isOwner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "minimumBurnAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "bytes32",
        name: "_pHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "_amountUnderlying",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "_nHash",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "_sig",
        type: "bytes",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "mintAuthority",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "mintFee",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "nextN",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "pendingOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "recoverTokens",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "selectorHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "status",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "contract RenERC20LogicV1",
        name: "",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract MintGatewayLogicV2",
        name: "_nextTokenOwner",
        type: "address",
      },
    ],
    name: "transferTokenOwnership",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint16",
        name: "_nextBurnFee",
        type: "uint16",
      },
    ],
    name: "updateBurnFee",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "_nextFeeRecipient",
        type: "address",
      },
    ],
    name: "updateFeeRecipient",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint16",
        name: "_nextMintFee",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "_nextBurnFee",
        type: "uint16",
      },
    ],
    name: "updateFees",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "_minimumBurnAmount",
        type: "uint256",
      },
    ],
    name: "updateMinimumBurnAmount",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "_nextMintAuthority",
        type: "address",
      },
    ],
    name: "updateMintAuthority",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint16",
        name: "_nextMintFee",
        type: "uint16",
      },
    ],
    name: "updateMintFee",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "bytes32",
        name: "_selectorHash",
        type: "bytes32",
      },
    ],
    name: "updateSelectorHash",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "bytes32",
        name: "_sigHash",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "_sig",
        type: "bytes",
      },
    ],
    name: "verifySignature",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class MintGatewayLogicV2__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MintGatewayLogicV2> {
    return super.deploy(overrides || {}) as Promise<MintGatewayLogicV2>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): MintGatewayLogicV2 {
    return super.attach(address) as MintGatewayLogicV2;
  }
  connect(signer: Signer): MintGatewayLogicV2__factory {
    return super.connect(signer) as MintGatewayLogicV2__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MintGatewayLogicV2Interface {
    return new utils.Interface(_abi) as MintGatewayLogicV2Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MintGatewayLogicV2 {
    return new Contract(address, _abi, signerOrProvider) as MintGatewayLogicV2;
  }
}
